import { Api } from "./Api.class";
const endpoint = "work_categories";
const workCategoryAPI = new Api(endpoint);
export default workCategoryAPI;
